export default __webpack_public_path__ + "static/media/151-single.0e87b753.png";